import { render, staticRenderFns } from "./questionItemZh.vue?vue&type=template&id=551ef8de&scoped=true"
import script from "./questionItemZh.vue?vue&type=script&lang=js"
export * from "./questionItemZh.vue?vue&type=script&lang=js"
import style0 from "./questionItemZh.vue?vue&type=style&index=0&id=551ef8de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ef8de",
  null
  
)

export default component.exports